import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'
import Alayout from '@/components/Alayout/Alayout'
import Notfound from '@/components/Notfound'
Vue.use(Router)

export const MenuRouter = [
  {
    path: '/Pending',
    component: Layout,
    redirect: 'Pending',
    meta: { icon: '#icondaichuli-' },
    show1: true,
    children: [{
      path: '',
      name: '待处理',
      component: () => import('@/views/Pending/Pending'),
      meta: { icon: '#icondaichuli-' }
    }]
  },
      {
    path: '/photo',
    component: () => import('@/views/supper/photo'),
    name: '拖拽图片',
    show: false,
    children: []
  },
  {
    path: '/Login',
    component: () => import('@/views/Login/Login'),
    name: '登录',
    show: false,
    children: []
  },
      {
    path: '/mobile',
    component: () => import('@/views/Login/moblie'),
    // redirect: '/',
    name: '手机端登录',
    show: false,
    children: []
  },
      {
    path: '/mobile/project',
    component: () => import('@/views/modile/xuncha'),
    name: '项目',
    show: false,
    meta: { showHeader: true },
    children: []
  },
  {
     path: '/mobile/Dexia',
     component: () => import('@/views/modile/User'),
      name: '深层水平位移详情页面',
      show: false,
      children: []
        // redirect: '/User/User',
        // show: false,
        // children: [{
        //   path: 'User',
        
   
        // }]
      },
      {
      path: '/mobile/projinfo',
      component: () => import('@/views/modile/wenjian'),
      name: '项目信息',
      show: false,
      meta: { showHeader: true },
      children: []
    },
      {
      path: '/mobile/dturenwu',
      component: () => import('@/views/modile/dturenwu'),
      name: 'DTU任务',
      show: false,
      meta: { showHeader: true },
      children: []
    },
        {
      path: '/mobile/detail',
      component: () => import('@/views/modile/detail'),
      name: '详情数据',
      show: false,
      meta: { showHeader: true },
      children: []
    },
    // /:title/:id/:mpID
      {
      path: '/mobile/jiancedian/:title/:id/:mpID',
      component: () => import('@/views/modile/jiancedian'),
      name: '监测点',
      show: false,
      meta: { showHeader: true },
      children: []
    },
       {
      path: '/mobile/quxiantu/:title/:mpID',
      component: () => import('@/views/modile/quxianpic'),
      name: '监测点',
      show: false,
      meta: { showHeader: true },
      children: []
    },
    {
      path: '/mobile/jiancetype',
      component: () => import('@/views/modile/weixiu'),
      name: '监测点类型',
      show: false,
      meta: { showHeader: true },
      children: []
    },
    {
    path: '/instructionBook/EA-HPI2S',
    component: () => import('@/views/instructionBook/eahpi2s.vue'),
    name: '倾角计资料预览',
    show: false,
    children: []
  },
    {
    path: '/instructionBook/EA-DHL4Pro',
    component: () => import('@/views/instructionBook/cexieyi.vue'),
    name: '测斜仪资料预览',
    show: false,
    children: []
  },
      {
    path: '/instructionBook/EA-DIVM1',
    component: () => import('@/views/instructionBook/qingxiezhendong.vue'),
    name: '倾斜与振动资料预览',
    show: false,
    children: []
  },
     {
    path: '/instructionBook/EA-HPI1',
    component: () => import('@/views/instructionBook/gaodingdu.vue'),
    name: '高精度资料预览',
    show: false,
    children: []
  },
     {
    path: '/instructionBook/EA-DHL3',
    component: () => import('@/views/instructionBook/quanfang.vue'),
    name: '全向位移计资料预览',
    show: false,
    children: []
  },
    {
    path: '/instructionBook/EA-DVM2',
    component: () => import('@/views/instructionBook/hunnitu.vue'),
    name: '4G分布式振动监测仪资料预览',
    show: false,
    children: []
  },
      {
    path: '/instructionBook/yeya',
    component: () => import('@/views/instructionBook/yeya.vue'),
    name: '液压水准资料预览',
    show: false,
    children: []
  },
     {
    path: '/instructionBook/shuiwei',
    component: () => import('@/views/instructionBook/shuiwei.vue'),
    name: '水位监测仪资料预览',
    show: false,
    children: []
  },
      {
    path: '/instructionBook/shengceng',
    component: () => import('@/views/instructionBook/shengceng.vue'),
    name: '水位监测仪资料预览',
    show: false,
    children: []
  },
  {
    path: '/bigscreen',
    component: () => import('@/views/bigscreen/bigscreen'),
    name: '大屏',
    show: false,
    children: []
  },
  
  // {
  //   path: '/home',
  //   component: () => import('@/views/home/Login'),
  //   name: '首页',
  //   show: false,
  //   children: []
  // },
  {
    path: '/VipLogin',
    component: () => import('@/views/Login/VipLogin'),
    name: '超级Vip',
    show: false,
    children: []
  },
  {
    path: '/Vipfirst',
    component: () => import('@/views/Login/Vipfirst'),
    name: '超级Vip首页',
    show: false,
    children: []
  },

  {
    path: '/Proj',
    component: Layout,
    name: '项目',
    meta: { icon: '#icongongcheng-' },
    children: [{
      path: 'BuildingProj',
      name: '在监测',
      component: () => import('@/views/Proj/BuildingProj'),
      meta: { icon: 'zaijiangongchengshigongxianchang' }
    }, {
      path: 'CompletedProj',
      name: '已完工',
      component: () => import('@/views/Proj/CompletedProj'),
      meta: { icon: 'yiwancheng' }
    }, {
      path: 'ProjectManagement',
      name: '项目管理',
      component: () => import('@/views/Proj/ProjectManagement'),
      meta: { icon: 'gongchengguanli' }
    }, {
      path: 'ChildPrj',
      name: '工程首页',
      show: false,
      component: () => import('@/views/Proj/ChildPrj')
    },
    {
      path: 'TerminalInfo/:id/:type/:DTUid',
      // path: 'TerminalInfo',
      name: '终端详情',
      component: () => import('@/views/Proj/TerminalInfo'),
      show: false,
    }, {
      path: 'CompletedChildPrj',
      name: '已完工工程首页',
      show: false,
      component: () => import('@/views/Proj/ChildPrj')
    }]
  },
  {
    path: '/Audit',
    component: Layout,
    name: '审核',
    meta: { icon: '#iconshenhe-' },
    children: [{
      path: 'UncompletedAudit',
      name: '未审核',
      component: () => import('@/views/Audit/UncompletedAudit'),
      meta: { icon: 'daishenhe' }
    }, {
      path: 'CompletedAudit',
      name: '已审核',
      component: () => import('@/views/Audit/CompletedAudit'),
      meta: { icon: 'yishenhe' }
    }]
  },
  {
    path: '/Device',
    component: Layout,
    meta: { icon: '#iconshebei-' },
    show1: false,
    children: [{
      path: '',
      name: '设备',
      component: () => import('@/views/Device/Device'),
      meta: { icon: '#iconshebei-' }
    }]
  },
  {
    path: '/Banben1',
    component: Layout,
    show: false,
    meta: { icon: '#iconbanben-' },
    children: [{
      path: '',
      name: '合格证下载',
      component: () => import('@/views/Banben/Banben1'),
      meta: { icon: '#iconbanben-' }
    },
    ]
  },
 
  {
    path: '/DevData',
    component: Layout,
    name: '文件',
    meta: { icon: '#iconzl-' },
    children: [{
      path: 'DevData',
      name: '下载资料',
      component: () => import('@/views/DevData/DevData'),
    }, {
      path: 'Attentation',
      name: '注意事项',
      component: () => import('@/views/DevData/Attentation'),
    }]
  },
  {
    path: '/Banben',
    component: Layout,
    show1: true,
    meta: { icon: '#iconbanben-' },
    children: [{
      path: '',
      name: '版本及功能说明',
      component: () => import('@/views/Banben/Banben'),
      meta: { icon: '#iconbanben-' }
    },
    ]
  },
   {
    path: '/orderjiekou',
    component: Layout,
    show: false,
    children: [{
      path: '',
      name: 'orderjiekou',
      component: () => import('@/views/Banben/Banben4'),
      meta: {  noCache: false // 不需要缓存
      }
    },
    ]
  },
    {
    path: '/IoTCardManagement',
    component: Layout,
    show1: true,
     meta: {
       keepAlive: true,  // 开启缓存
    isFromOrderJiekou: false // 新增：标记是否从orderjiekou返回

      },
    children: [{
      path: '',
      name: '物联网卡管理',
      component: () => import('@/views/Banben/Banben3'),
      meta: {
   
        keepAlive: true // 确保子路由也缓存
      }
    },
    ]
  },
  {
    path: '/User',
    component: Layout,
    redirect: '/User/User',
    show: false,
    children: [{
      path: 'User',
      name: '用户',
      component: () => import('@/views/User/User')
    }]
  },
  {
    path: '/Report',
    component: Layout,
    show: false,
    redirect: '/Report/NewReport',
    children: [{
      path: 'NewReport',
      name: '报表',
      component: () => import('@/views/Report/NewReport')
    }, {
      path: 'NewReport_datatable/:id',
      name: '数据报表',
      // meta: {
      //   keepAlive:true
      // },
      component: () => import('@/views/Report/NewReport_datatable')
    }, {
      path: 'HistoryReport',
      name: '历史报表',
      component: () => import('@/views/Report/HistoryReport')
    }, {
      path: 'NewReport_detail/:id/:type',
      name: '数据报表详情',
      component: () => import('@/views/Report/NewReport_detail')
    }, {
      path: 'OldReport_detail/:id/:type',
      name: '旧数据报表',
      component: () => import('@/views/Report/NewReport_detail')
    }, {
      path: 'OldReport_datatable/:id',
      name: '旧数据报表详情',
      component: () => import('@/views/Report/NewReport_datatable')
    }, {
      path: 'HistoryReport_datatable/:id',
      name: '历史数据报表详情',
      component: () => import('@/views/Report/NewReport_datatable')
    }
    ]
  },
  {
    path: '/MonitorPoint',
    component: Layout,
    show: false,
    redirect: '/MonitorPoint/MonitorPoint',
    children: [{
      path: 'MonitorPoint',
      name: '监测点',
      component: () => import('@/views/MonitorPoint/MonitorPoint')
    }, 
      {
    path: 'photo',
    component: () => import('@/views/supper/photo'),
    name: '拖拽图片',
    // show: false,
    // children: []
  },
    {
      path: 'MonitorPointProject/:title/:id/:mpID',
      name: '历史数据',
      // props: true,
      component: () => import('@/views/MonitorPoint/MonitorPointProject.vue')
    },
    {
    path: 'viewjue/:title/:id/:mpID',
    name: '视觉位移历史数据',
    component: () => import('@/views/viewjue/viewjue')
    },
      // {
      //   path: 'addRtk',
      //   name: 'addRtk',
      //   component: () => import('@/views/Rtk/addRtk')
      // }
    ]
  },
  {
    path: '/Task',
    component: Layout,
    redirect: '/Task/DTUList',
    show: false,
    children: [
      {
        path: 'Task',
        name: '任务',
        component: () => import('@/views/Task/Task')
      },
      // {
      //   path: 'DTUTask',
      //   name: 'DTU任务',
      //   component: () => import('@/views/Task/DTUTask')
      // },
      {
        path: 'DTUList',
        name: 'DTUList',
        component: () => import('@/views/Task/DTUList')
      }]
  },
  {
    path: '/Rtk',
    component: Layout,
    redirect: '/Rtk/Rtk',
    show: false,
    children: [
      {
        path: 'Rtk',
        name: 'Rtk',
        component: () => import('@/views/Rtk/Rtk')
      },
      {
        path: 'addRtk',
        name: 'addRtk',
        component: () => import('@/views/Rtk/addRtk')
      }
    ]
  },
  {
    path: '/yujing',
    component: Layout,
    redirect: '/yujing/yujing',
    show: false,
    children: [
      {
        path: 'yujing',
        name: '预警推送',
        component: () => import('@/views/yujing/index.vue')
      }]
  },
    {
    path: '/getdata',
    component: Layout,
    redirect: '/getdata/getdata',
    show: false,
    children: [
      {
        path: 'getdata',
        name: '预警推送',
        component: () => import('@/views/getdata/index.vue')
      }]
  },
  {
    path: '/Aoverview',
    component: Alayout,
    show: false,
    children: [{
      path: '',
      name: '异步消息中间件',
      component: () => import('@/aviews/Overview/overview'),
    }],
  },
  // {
  //   path: '/Energy',
  //   component: Alayout,
  //   show: false,
  //   children: [{
  //     path: '',
  //     name: '能源',
  //     component: () => import('@/aviews/Energy/energy'),
  //   }],
  // },
  {
    path: '/Exceptions',
    component: Alayout,
    show: false,
    children: [{
      path: '',
      name: '异常',
      component: () => import('@/aviews/Exceptions/exceptions'),
    }],
  },
  // {
  //   path: '*',
  //   name: "Notfound",
  //   show:false,
  //   component: Notfound,
  //   children: []
  //   },
  // {
  //   path: '*',

  //   redirect: "/404",

  //   show:false,
  //   children: []
  // },
]

export default new Router({
  routes: MenuRouter,
  // scrollBehavior: () => ({ y: 0 }),
})



// WEBPACK FOOTER //
// ./src/router/index.js